import { render, staticRenderFns } from "./exchange-table.vue?vue&type=template&id=41f3ff92&scoped=true&"
import script from "./exchange-table.vue?vue&type=script&lang=js&"
export * from "./exchange-table.vue?vue&type=script&lang=js&"
import style0 from "./exchange-table.vue?vue&type=style&index=0&id=41f3ff92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41f3ff92",
  null
  
)

export default component.exports